import { useScrollDetection } from '@wix/package-picker-components';
import React from 'react';

export const useScrollToTopButtonVisibility = (
  cardsContainerRef: React.RefObject<any>,
) => {
  const [shouldShowScrollToTopButton, setShouldShowScrollToTopButton] =
    React.useState(false);

  const handleVisibilityChange = (isCardsContainerOutOfViewPort) => {
    setShouldShowScrollToTopButton(isCardsContainerOutOfViewPort);
  };

  useScrollDetection({
    ref: cardsContainerRef,
    offset: 0,
    cb: handleVisibilityChange,
  });

  return {
    shouldShowScrollToTopButton,
  };
};
